<template>
  <div
    class="form-group date-select"
    :class="{ 'required': required, 'error-input': errors.has('day') || errors.has('month') || errors.has('year') }">
    <label>{{ label }}</label>
    <div class="grid">
      <div>
        <input
          type="text"
          class="form-control"
          :placeholder="$t('fields.day')"
          maxlength="2"
          name="day"
          :disabled="disabled"
          @keydown="$filter.numeric($event)"
          v-model="form.day"
          v-validate="'required'">
        <span v-show="errors.has('day')" class="error-help">{{ errors.first('day') }}</span>
      </div>
      <div>
        <select
          class="form-control"
          name="month"
          :disabled="disabled"
          v-model="form.month"
          v-validate="'required'">
          <option value="">{{ $t('fields.month') }}</option>
          <option v-for="(month, index) in months" :value="index">{{ $t(`months.${month}`) }}</option>
        </select>
        <span v-show="errors.has('month')" class="error-help">{{ errors.first('month') }}</span>
      </div>
      <div>
        <input
          type="text"
          class="form-control"
          :placeholder="$t('fields.year')"
          maxlength="4"
          name="year"
          :disabled="disabled"
          @keydown="$filter.numeric($event)"
          v-model="form.year"
          v-validate="'required'">
        <span v-show="errors.has('year')" class="error-help">{{ errors.first('year') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Texto'
    },
    model: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      months,
      form: {
        day: '',
        month: '',
        year: ''
      }
    };
  },
  watch: {
    'form.day': function (val) {
      if (parseInt(val) > 31 || parseInt(val) < 1) {
        this.form.day = '';
      }
    },
    'form.year': function (val) {
      let year = (new Date()).getFullYear();
      if (parseInt(val) > year || (val.length === 4 && parseInt(val) < 1900)) {
        this.form.year = '';
      }
    },
    'form': {
      handler (val) {
        let model = this.model.split('.');
        if (val.day && val.month !== '-' && val.year && val.year.length === 4) {
          let date = new Date(val.year, val.month, val.day, 0, 0, 0);
          this.$store.commit('setDate', {
            prop: model[0],
            key: model[1],
            value: date
          });
        } else {
          this.$store.commit('setDate', {
            prop: model[0],
            key: model[1],
            value: null
          });
        }
      },
      deep: true
    },
    '$store.state.valid': function (val) {
      if (val) {
        this.$validator.validateAll()
        .then(result => {
          this.$store.commit('setValid', false);
        });
      }
    }
  }
};
</script>

<style lang="scss">
.date-select {
  .grid {
    grid-template-columns: 1fr 2fr 1fr;
  }
}
@media (max-width: 768px) {
  .date-select {
    .grid > div {
      margin: 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/util/DateSelect.vue